import angular from 'angular';
import * as R from 'ramda';

export default function CustomerAdministrationDirectiveController(
  $scope,
  $location,
  $q,
  copy,
  loaderService,
  alerts,
  orgDataService
) {
  const vm = this;

  vm.appIsLoaded = false;
  vm.canAccessUA = false;
  vm.canSeeMultipleCustomers = false;
  vm.syncUsersButtonIsDisabled = false;
  vm.selectedCustomerId = $location.search().customerId || '-1';
  vm.handleSelectCustomerListChange = _handleSelectCustomerListChange;
  vm.handleAdministerUsersClick = _handleAdministerUsersClick;
  vm.refreshBank = _refreshBank;

  _initEventListeners();

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdLoadApp = $q.defer();

    vm.dfdRefreshCustomersList = _refreshCustomersList();
    const dfdGetServices = _getServices();
    const dfdGetUALinkages = _getUserAdministrationLinkages();

    $q.all(
      [
        vm.dfdRefreshCustomersList,
        dfdGetServices,
        dfdGetUALinkages
      ]
    ).then(dfdLoadApp.resolve);

    dfdLoadApp.promise.then(() => {
      vm.appIsLoaded = true;
    });
  }

  function _initEventListeners() {
    $scope.$on('bankDirectiveEventsSet', () => {
      _refreshBank(vm.selectedCustomerId);
    });

    $scope.$on('refreshCustomer', (event, opt) => {
      if (opt.customerId === Number(vm.selectedCustomerId)) {
        _refreshBank(vm.selectedCustomerId);
      }
    });
  }

  function _refreshCustomersList() {
    const dfdRefresh = $q.defer();
    orgDataService.getActiveCustomers().then(
      (response) => {
        const customers = [];
        angular.forEach(
          response.data.result,
          (currentCustomer) => {
            const customer = {
              customerId: currentCustomer.customerId.toString(),
              customerName: currentCustomer.customerName,
              accountCode: currentCustomer.accountCode,
            };
            customers.push(customer);
          }
        );

        vm.customers = customers;

        if (vm.customers.length > 1) {
          vm.canSeeMultipleCustomers = true;
        } else {
          vm.canSeeMultipleCustomers = false;
          vm.selectedCustomer = vm.customers[0];
          vm.selectedCustomerId = vm.selectedCustomer.customerId;
          _refreshBank(vm.selectedCustomerId);
        }

        dfdRefresh.resolve();
      }
    );
    return dfdRefresh.promise;
  }

  function _getServices() {
    const dfdGetServices = $q.defer();
    orgDataService.getServices().then((response) => {
      vm.services = response.data.result;
      dfdGetServices.resolve();
    });

    return dfdGetServices.promise;
  }

  function _getUserAdministrationLinkages() {
    const dfdGetServices = $q.defer();
    orgDataService.getUserInfo()
      .then((cResponse) => {
        const navigationLinkItems = R.filter(
          R.propEq('code', 'AdminUserAdmin'),
          cResponse.data.navigation
        );

        if (navigationLinkItems.length > 0) {
          vm.uaURL = navigationLinkItems[0].anchorURL;
          vm.canAccessUA = true;
        } else {
          vm.uaURL = null;
          vm.canAccessUA = false;
        }

        dfdGetServices.resolve();
      });
    return dfdGetServices.promise;
  }

  function _handleSelectCustomerListChange() {
    const customerId = vm.selectedCustomerId;
    _refreshBank(customerId);
  }

  function _handleAdministerUsersClick($event) {
    $event.stopPropagation();
    const dfdRefresh = $q.defer();
    loaderService.showViewLoader = true;
    orgDataService.getUserInfo()
      .then((cResponse) => {
        const navigationLink = R.filter(
          R.propEq('code', 'AdminUserAdmin'),
          cResponse.data.navigation
        );

        let url = navigationLink[0].anchorURL;
        if (vm.selectedCustomerId > 0) {
          url = `${url}?customerId=${vm.selectedCustomerId}`;
        }
        $location.url(url);
        loaderService.showViewLoader = false;
        dfdRefresh.resolve();
      });
    return dfdRefresh.promise;
  }

  function _refreshBank(customerId) {
    const dfdRefresh = $q.defer();
    loaderService.showViewLoader = true;
    orgDataService.getCustomer(customerId)
      .then((cResponse) => {
        vm.selectedCustomer = cResponse.data;
        vm.selectedCustomer.hasLogo = vm.selectedCustomer.logoDocumentId !== null;
        orgDataService.getCustomerAccess(customerId)
          .then((csResponse) => {
            vm.selectedCustomer.customerServices = csResponse.data.result;
            loaderService.showViewLoader = false;
            dfdRefresh.resolve();
          });
      });
    return dfdRefresh.promise;
  }
}


CustomerAdministrationDirectiveController.$inject = [
  '$scope',
  '$location',
  '$q',
  'copy',
  'loaderService',
  'alerts',
  'orgDataService'
];
